import Dashboard from "../../layouts/Dashboard";
import Home from "../../layouts/Home";

import {makeRoutes, publicRoutes, route} from "./utils";

const allowed = publicRoutes.concat([
  route("/panel", Dashboard),
  route("/", Home)
]);

export default makeRoutes(allowed, [], route("/", Home));
